import Vue from 'vue'
import Router from 'vue-router'
// 页面组件
import Index from '@/views/index'
import Go from '@/views/go'
import Product from '@/views/product'
import Scientific from '@/views/scientific'
import News from '@/views/news'
import Personnel from '@/views/Personnel'
import lookpdf from '@/views/pdf'
import articelG from '@/views/articelG'
import Page404 from '@/views/error/404'
Vue.use(Router)
    /**
     * 错误页面
     */
    // const errorPage = [
    //   {
    //     path: '*',
    //     name: '404',
    //     component: Page404
    //   }
    // ]
const router = new Router({
    routes: [
        // errorPage,
        {
            path: '/404',
            name: 'Page404',
            component: Page404
        },
        {
            path: '/articelG',
            name: 'articelG',
            component: articelG
        },
        {
            path: '/',
            name: 'Index',
            component: Index
        }, {
            path: '/go',
            name: 'Go',
            component: Go
        },
        {
            path: '/product',
            name: 'Product',
            component: Product
        },
        {
            path: '/scientific',
            name: 'Scientific',
            component: Scientific
        }, {
            path: '/news',
            name: 'News',
            component: News
        }, {
            path: '/personnel',
            name: 'Personnel',
            component: Personnel
        },
        {
            path: '/lookpdf',
            component: 'lookpdf',
            component: lookpdf
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    },
    history: true
})
router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {
        from.name ? next({
            name: from.name
        }) : next('/');
    } else {
        next(); //如果匹配到正确跳转
    }
});
const routerPush = Router.prototype.push
export default router


// WEBPACK FOOTER //
// ./src/router/index.js